import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import Recaptcha from "react-recaptcha";
import { requestInformationORScheduleAnAppointment } from "../../store/actions";
import Logo from "../../assets/images/logo.png";
import { FormField } from "../../sharedComponents/formField";
import { required, email, max5 } from "../../constants/formValidators";
import { NotificationManager } from "react-notifications";

export const RequestInformation = ({ handleSubmit, title, requestInformationORScheduleAnAppointment, history }) => {
	const [recaptcha, setRecaptcha] = useState(null);
	const sitekey = "6LcjhRATAAAAAHGjWnGCvzPzl2sNq4uHjAFY05Xp";

	const verifyCallback = (response) => {
		setRecaptcha(response);
	};

	const expiredCallback = () => {
		setRecaptcha(null);
	};

	const saveForm = (values) => {
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				history.push("/");
				NotificationManager.success(
					"You should typically receive a response from a team member within 24 to 48 hours",
					"",
					5000
				);
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};

		const errorHandler = (event) => {
			event && event.error_code === "VALIDATION_ERROR" && NotificationManager.error("Invalid Fields", "", 5000);
		};

		requestInformationORScheduleAnAppointment({ ...values, subject: title }, successHandler, errorHandler);
	};

	return (
		<React.Fragment>
			<header>
				<div className="container">
					<div className="logo-container">
						<Link to={"dashboard"}>
							<img src={Logo} alt="MEDI WEIGHT LOSS" />
						</Link>
					</div>
				</div>
			</header>
			<div className="container">
				<h3 className="mt-3"> {title}</h3>
				<div className="card p-4 mt-3 border-0 br-10">
					<form className="row" onSubmit={handleSubmit(saveForm)}>
						<div className="col-4">
							<Field
								name="first_name"
								label="First Name"
								placeholder="Enter your name"
								type="text"
								component={FormField}
								validate={[required]}
							/>
						</div>
						<div className="col-4">
							<Field
								name="email"
								label="Email Address"
								placeholder="Enter your email address"
								type="text"
								component={FormField}
								validate={[required, email]}
							/>
						</div>
						<div className="col-4">
							<Field
								name="zip"
								label="Zip Code"
								placeholder="Enter your zip code"
								type="text"
								component={FormField}
								validate={[required, max5]}
							/>
						</div>
						<div className="col-12 ">
							<Field
								name="comments"
								label="Message"
								type="textarea"
								component={FormField}
								className="form-control"
								validate={[required]}
							/>
						</div>
						<div className="col-12 ">
							<Recaptcha
								sitekey={sitekey}
								size="normal"
								render="explicit"
								verifyCallback={verifyCallback}
								expiredCallback={expiredCallback}
							/>
						</div>

						<div className="col-12 mt-3 d-flex justify-content-end">
							<button className="btn text-primary-dark" onClick={() => history.push("/signin")}>
								Cancel
							</button>
							<button className="btn btn-primary text-uppercase ml-3" disabled={recaptcha ? false : true}>
								submit request
							</button>
						</div>
					</form>
					<p>
						By submitting this form, you will receive exciting news, specials, weight loss tips, and recipes!
					</p>
				</div>
			</div>
		</React.Fragment>
	);
};

const mapDispatchToProps = {
	requestInformationORScheduleAnAppointment
};

const mapStateToProps = () => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "RequestInformationForm",
		enableReinitialize: true
	})(RequestInformation)
);
